import { render } from "./SubgrupoList.vue?vue&type=template&id=05d0dad0&scoped=true"
import script from "./SubgrupoList.vue?vue&type=script&lang=js"
export * from "./SubgrupoList.vue?vue&type=script&lang=js"

import "./SubgrupoList.vue?vue&type=style&index=0&id=05d0dad0&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\rotcen_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d0dad0"]])

export default __exports__